import "./AppInfo.css";

import { useState } from "react";
import packageJson from "../../../package.json";
import { useAppContext } from "../../classes/contexts/AppContext";
import IconsEnum from "../../classes/enums/IconsEnum";
import { iconMapping } from "../../config/iconConfig";
import config from "../../config/oAuthConfig";
import useTranslation from "../../hooks/i18n/useTranslation";
import CloseButton from "../closeButton/CloseButton";
import { ReactComponent as LogoSpineSim } from "../logos/SPINEsim.svg";

const AppInfo = () => {
  const { t } = useTranslation();
  const { hidePopup } = useAppContext();
  const [showLegalInformation, setShowLegalInformation] = useState(false);
  const currentYear = new Date().getFullYear();

  const closePopup = () => {
    hidePopup();
  };

  const IconManufacturer = iconMapping[IconsEnum.CEMARKMANUFACTURER];
  const IconUDI = iconMapping[IconsEnum.CEMARKUDI];
  const IconNotifiedBody = iconMapping[IconsEnum.CEMARKNOTIFIEDBODY];
  const IconBookInfo = iconMapping[IconsEnum.CEMARKBOOKINFO];
  const processDetails =
    process.env.REACT_APP_PROCESS_DETAILS || "07_00_101 11 Feb 2026";

  return (
    <div
      className={`App-info-container ${
        showLegalInformation ? "App-info-container-legal" : ""
      }`}
    >
      <CloseButton onClose={closePopup} />
      {!showLegalInformation && (
        <div className="App-title-windows">
          <LogoSpineSim className="App-logo-spinesim" />
        </div>
      )}

      {!showLegalInformation && (
        <div className="App-build-info">
          <div className="App-title-widgets App-info-version">{`Version ${packageJson?.version}`}</div>
          <div className="App-text-medium">
            {`(build ${process.env.REACT_APP_BUILD_NUMBER})`}
          </div>
          <button
            className="App-text-medium App-styled-link App-link-button"
            onClick={() => setShowLegalInformation(true)}
            type="button"
          >
            Legal information
          </button>
        </div>
      )}

      {!showLegalInformation ? (
        <>
          <div className="App-warning">{t("42")}</div>

          <div className="App-copyright">
            <span className="App-copyright-text">
              {`© ${currentYear}, MDsim`}
              <br />
              All Rights Reserved
            </span>
            <a
              className="App-text-medium App-styled-link"
              href={config.mdsimWebUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              MDsim
            </a>
          </div>
        </>
      ) : (
        <div className="App-ce-mark-container">
          <div className="App-ce-mark-content">
            <div className="App-legal-header">
              <div className="App-legal-md-box">MD</div>
              <div className="App-legal-spinesim">SPINEsim</div>
            </div>
            <div className="App-legal-grid">
              <div className="App-manufacturer-section">
                <IconManufacturer className="App-icon-manufacturer" />
                <div className="App-manufacturer-text">
                  MDsim S.A.
                  <br />
                  9 Av des Hauts-Fourneaux
                  <br />
                  L-4362 Esch-sur-Alzette
                  <br />
                  Luxembourg
                </div>
              </div>

              <div className="App-date-section">
                <IconManufacturer className="App-icon-date" />
                <div className="App-date-text">
                  {process.env.REACT_APP_MANUFACTURE_DATE || "YYYY-MM-DD"}
                </div>
              </div>

              <div className="App-udi-section">
                <IconUDI className="App-icon-udi" />
                <div className="App-udi-text">
                  {`(01) ${process.env.REACT_APP_UDI_NUMBER || "05404043300014"}`}
                  <br />
                  {`(8012) 1.x.y`}
                </div>
              </div>

              <div className="App-ref-section">
                <div className="App-ref-box">REF</div>
                <div className="App-ref-text">SPINEsim</div>
              </div>
              <div className="App-ce-marks-row">
                <IconBookInfo className="App-icon-book-info" />
                <IconNotifiedBody className="App-icon-notified-body" />
                <div className="App-rx-only">&#8478; only</div>
              </div>
              <div className="App-process-details">{processDetails}</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AppInfo;
